import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";

/**
 * Returns a debounced value.
 *
 * @param value - The value to debounce.
 * @param wait - The number of milliseconds to delay.
 * @returns - The debounced value.
 */
export function useDebounced<T>(value: T, wait?: number) {
  const [debounced, setDebounced] = useState<T>(value);
  const fn = useMemo(
    () => debounce((value: T) => setDebounced(value), wait, { leading: false, trailing: true }),
    [wait],
  );

  useEffect(() => {
    fn(value);
  }, [value, fn]);

  return debounced;
}
